/**
 * Given two strings and order (desc=false/true), return sorting order.
 * @param {string} str1 
 * @param {string} str2 
 * @param {boolean} [desc] should descend order return
 * @returns {1|-1}
 */
export function sortString(str1, str2, desc=false) {
    const order = desc ? -1 : 1
    return str1.toLowerCase() > str2.toLowerCase() ? order : order * -1
}